/**
 * Auto Resolve Section Component
 * 
 * Displays the auto-resolve toggle and configuration options.
 * Users can enable/disable automatic conflict resolution and
 * configure which types of conflicts to handle automatically.
 */

import React from "react";
import { tWithKeyAttr as t } from "../../../../i18nHelper";
import { IAutoResolveSettings, IAutoResolveOption } from "../../types/conflictsDetector.types";
import styles from "../../appointmentsPage.module.css";

interface IAutoResolveSectionProps {
  settings: IAutoResolveSettings;
  onToggleEnabled: () => void;
  onToggleOption: (optionId: string) => void;
}

const AutoResolveSection: React.FC<IAutoResolveSectionProps> = ({
  settings,
  onToggleEnabled,
  onToggleOption
}) => {
  return (
    <div className={styles.autoResolveSection}>
      <div className={styles.autoResolveHeader}>
        <div className={styles.autoResolveTitle}>
          {t("CONFLICTS_AUTO_RESOLVE_TITLE")}
        </div>
        <div 
          className={`${styles.conflictToggleSwitch} ${settings.enabled ? styles.conflictToggleSwitchActive : ''}`}
          onClick={onToggleEnabled}
          role="switch"
          aria-checked={settings.enabled}
          tabIndex={0}
          onKeyDown={(e) => e.key === 'Enter' && onToggleEnabled()}
        />
      </div>
      <div className={styles.autoResolveDescription}>
        {t("CONFLICTS_AUTO_RESOLVE_DESC")}
      </div>
      <div className={styles.autoResolveOptions}>
        {settings.options.map((option: IAutoResolveOption) => (
          <div 
            key={option.id}
            className={`${styles.autoResolveOption} ${option.enabled ? styles.autoResolveOptionSelected : ''}`}
            onClick={() => onToggleOption(option.id)}
            role="checkbox"
            aria-checked={option.enabled}
            tabIndex={0}
            onKeyDown={(e) => e.key === 'Enter' && onToggleOption(option.id)}
          >
            <div className={styles.autoResolveOptionTitle}>
              {t(option.titleKey)}
            </div>
            <div className={styles.autoResolveOptionDescription}>
              {t(option.descriptionKey)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AutoResolveSection;
